<template>
    <div>
        <div class="nav">
            <v-head></v-head>
        </div>
        <v-route :bindData="bindData"></v-route>
        <div class="container">
            <v-breadcrumb value1="首页" value2="旅游服务" value3="旅游指南"  :url="url"></v-breadcrumb>
            <div class="container_box mt20 mb20">
                <h2>{{data.title}}</h2>
                <video v-if="data.href" class="content" :src="data.href" style="width: 100%;padding-bottom: 20px" controls="controls" object-fit="cover">
                    您的浏览器不支持 video 标签。
                </video>
                <div class="content" style="padding-bottom: 20px" v-html="data.content" ></div>



            </div>
        </div>


        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                data:{
                    title:null
                },
                value2:null,
                value3:null,
                value4:null,
                image:null,
                ljcode:null,
                url:['lyzn','',''],
                bindData:[
                    {
                        name:'旅游指南',
                        url:'#/lyzn?ljcode=lyzn&articleId=8a9d2ba16ec4607c016ec52657500000&columnId=40288a9d6e91c70a016e91d09edb0019&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d09edb0019'
                    },
                    {
                        name:'在线咨询',
                        url:'http://wpa.qq.com/msgrd?v=3&uin=1420561821&site=qq&menu=yes',
                        cid:'2c9a4c9b6ea63d8c016ea6474f040002'
                    },
                    {
                        name:'投诉建议',
                        url:'#/tsjy?ljcode=tsjy&columnId=40288a9d6e91c70a016e91d0f659001b&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d0f659001b'
                    }
                    ,
                    {
                        name:'旅游电话',
                        url:'#/lydh?ljcode=lydh&articleId=8a9d2ba16e01cf0d016e64426677010b&columnId=40288a9d6e91c70a016e91d12541001c&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d12541001c'
                    }
                    ,
                    {
                        name:'出游宝典',
                        url:'#/cybd?ljcode=cybd&articleId=8a9d2ba16e01cf0d016e64728b7a0115&columnId=40288a9d6e91c70a016e91d15ea2001d&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d15ea2001d'
                    }
                    ,
                    {
                        name:'常见问题',
                        url:'#/cjwt?ljcode=cjwt&articleId=8a9d2ba16ec4607c016ec59b69000005&columnId=40288a9d6e91c70a016e91d1972a001e&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d1972a001e'
                    }
                    ,
                    {
                        name:'天气预报',
                        url:'#/tqyb?ljcode=tqyb&columnId=40288a9d6e91c70a016e91d1c39a001f&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        cid:'40288a9d6e91c70a016e91d1c39a001f'
                    }
                ]
            }
        },
        created() {
            this.getDetail();
        },
        watch:{
            $route:function (newValue) {
                console.log(newValue);
                let that = this;
                let ljcode = newValue.query.ljcode;
                let articleId = newValue.query.articleId;
                let rootColumnId = newValue.query.rootColumnId;
                let columnId = newValue.query.columnId;
                this.value2 = this.common.getValue2(ljcode);
                console.log(this.value2);
                this.url = [ljcode,rootColumnId,columnId]
                let url = `${api}/api/cms/article/detail?articleId=${articleId}`;
                this.common.axios.get(url).then(v=>{
                    that.data = v.data.data;
                    that.value3 = that.data.title;
                });

            }
        },
        methods:{
            getDetail(){
                let that = this;
                let ljcode = this.$route.query.ljcode;
                let articleId = this.$route.query.articleId;
                let rootColumnId = this.$route.query.rootColumnId;
                let columnId = this.$route.query.columnId;
                this.value2 = this.common.getValue2(ljcode);
                console.log(this.value2);
                this.url = [ljcode,rootColumnId,columnId]

                let url = `${api}/api/cms/article/detail?articleId=${articleId}`;
                this.common.axios.get(url).then(v=>{
                    console.log(v.data.data);
                    that.data = v.data.data;
                    that.data.content = that.data.content.replace(/\s+/g," ");

                    that.value3 = that.data.title;
                });
            },


        },
        components:{
            "v-route":route,
        }


    }
</script>

<style lang="less" scoped>
    .container{
    }
    .nav{
        height: 350px;
        background: url("../../assets/img/headerbanner.jpg");
    }
    .container_box{
        background: white;
        padding: 0 150px;
        h2{
            font-size: 36px;
            line-height: 70px;
            height: 70px;
            color: black;
            letter-spacing: 5px;
            text-align: center;
            a{
                color: black;
            }
            a:hover{
                color: #85878F;
                text-decoration: underline;
            }
        }

        text-align: justify;


    }



</style>
<style lang="less">
    .content{
        p{
            text-indent: 0em !important;
            line-height: 32px !important;
            font-size: 14px !important;
            color: #666666 !important;
           
            span{
                font-size: 14px !important;
                color: #666666 !important;
            }
        }
        img{
            max-width: 100% !important;
        }
        table,table tr th, table tr td { border:1px solid black;vertical-align:middle }
    }
</style>
